import React, { useState, useEffect } from "react";
import axios from "axios";
import { API } from "../api";
import { useAuth } from "../App";

const JOURS = ["Lun", "Mar", "Mer", "Jeu", "Ven"];
const JOURS_IDX = [1, 2, 3, 4, 5]; // getDay() values (1=lundi ... 5=vendredi)

function TT() {
  const { token } = useAuth();
  const [tts, setTts] = useState([]);
  const [dateDebut, setDateDebut] = useState("");
  const [dateFin, setDateFin] = useState("");
  const [commentaire, setCommentaire] = useState("");
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [demiJournee, setDemiJournee] = useState("entiere");
  const [selecting, setSelecting] = useState("start");
  const [hovered, setHovered] = useState(null);
  const today = new Date();
  const [viewMonth, setViewMonth] = useState(today.getMonth());
  const [viewYear, setViewYear] = useState(today.getFullYear());

  // Récurrence
  const [showRecurrence, setShowRecurrence] = useState(false);
  const [recJours, setRecJours] = useState([]);
  const [recDebut, setRecDebut] = useState("");
  const [recFin, setRecFin] = useState("");
  const [recCommentaire, setRecCommentaire] = useState("");
  const [recLoading, setRecLoading] = useState(false);

  const loadTTs = () => {
    axios.get(API + "/tt/mine", {
      headers: { Authorization: "Bearer " + token }
    }).then(r => setTts(r.data));
  };

  useEffect(() => { loadTTs(); }, [token]);

  const toStr = d => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return y + "-" + m + "-" + day;
  };

  const handleDayClick = (dateStr) => {
    if (selecting === "start" || (dateDebut && dateStr < dateDebut)) {
      setDateDebut(dateStr);
      setDateFin("");
      setDemiJournee("entiere");
      setSelecting("end");
    } else {
      setDateFin(dateStr);
      setDemiJournee("entiere");
      setSelecting("start");
    }
  };

  const isInRange = (dateStr) => {
    const end = hovered || dateFin;
    if (!dateDebut || !end) return false;
    return dateStr >= dateDebut && dateStr <= end;
  };

  const isWeekend = d => d.getDay() === 0 || d.getDay() === 6;

  const renderMonth = (month, year) => {
    const firstDay = new Date(year, month, 1).getDay();
    const offset = firstDay === 0 ? 6 : firstDay - 1;
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const monthName = new Date(year, month).toLocaleDateString("fr-FR", { month: "long", year: "numeric" });
    const cells = [];
    for (let i = 0; i < offset; i++) cells.push(null);
    for (let d = 1; d <= daysInMonth; d++) cells.push(new Date(year, month, d));
    const todayStr = toStr(today);
    return (
      <div key={year + "-" + month}>
        <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 8, textTransform: "capitalize", color: "#333", textAlign: "center" }}>{monthName}</div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 30px)", gap: 1 }}>
          {["L","M","M","J","V","S","D"].map((d, i) => (
            <div key={i} style={{ textAlign: "center", fontSize: 10, color: "#aaa", padding: "3px 0", fontWeight: 500 }}>{d}</div>
          ))}
          {cells.map((d, i) => {
            if (!d) return <div key={"e" + i} />;
            const isWknd = isWeekend(d);
            const dateStr = toStr(d);
            const isStart = dateStr === dateDebut;
            const isEnd = dateStr === (dateFin || hovered);
            const inRange = isInRange(dateStr);
            const isToday = dateStr === todayStr;
            return (
              <div
                key={dateStr}
                onClick={() => { if (!isWknd) handleDayClick(dateStr); }}
                onMouseEnter={() => { if (selecting === "end" && dateDebut && !isWknd) setHovered(dateStr); }}
                onMouseLeave={() => setHovered(null)}
                style={{
                  textAlign: "center", fontSize: 12, padding: "5px 2px",
                  borderRadius: (isStart || isEnd) ? "50%" : inRange ? 3 : 4,
                  cursor: isWknd ? "default" : "pointer",
                  background: (isStart || isEnd) ? "#3B8C6E" : inRange ? "#C8EDD9" : "transparent",
                  color: (isStart || isEnd) ? "#fff" : isWknd ? "#ccc" : isToday ? "#3B8C6E" : "#333",
                  fontWeight: (isToday || isStart || isEnd) ? 700 : 400,
                  outline: (isToday && !isStart && !isEnd) ? "2px solid #3B8C6E" : "none",
                  outlineOffset: -2,
                }}
              >
                {d.getDate()}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const months = [];
  for (let i = 0; i < 2; i++) {
    const m = (viewMonth + i) % 12;
    const y = viewYear + Math.floor((viewMonth + i) / 12);
    months.push(renderMonth(m, y));
  }

  const isJourUnique = dateDebut && dateFin && dateDebut === dateFin;

  const handleSubmit = async () => {
    if (!dateDebut || !dateFin) { setError("Veuillez selectionner les dates."); return; }
    const periode = isJourUnique ? demiJournee : "entiere";
    try {
      await axios.post(API + "/tt",
        { date_debut: dateDebut, date_fin: dateFin, commentaire, periode },
        { headers: { Authorization: "Bearer " + token } }
      );
      setSuccess("Jours de TT declares !");
      setDateDebut(""); setDateFin(""); setCommentaire(""); setDemiJournee("entiere");
      setSelecting("start");
      setError("");
      setTimeout(() => setSuccess(""), 3000);
      loadTTs();
    } catch (err) {
      setError("Erreur lors de la declaration.");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Supprimer cette declaration de TT ?")) return;
    await axios.delete(API + "/tt/" + id,
      { headers: { Authorization: "Bearer " + token } }
    );
    loadTTs();
  };

  const handleRecurrence = async () => {
    if (recJours.length === 0) { setError("Selectionnez au moins un jour."); return; }
    if (!recDebut || !recFin) { setError("Selectionnez une plage de dates."); return; }
    if (recFin < recDebut) { setError("La date de fin doit etre apres la date de debut."); return; }

    // Générer toutes les dates correspondantes
    const dates = [];
    const cur = new Date(recDebut + "T12:00:00");
    const end = new Date(recFin + "T12:00:00");
    while (cur <= end) {
      if (recJours.includes(cur.getDay())) {
        const y = cur.getFullYear();
        const m = String(cur.getMonth() + 1).padStart(2, "0");
        const d = String(cur.getDate()).padStart(2, "0");
        dates.push(`${y}-${m}-${d}`);
      }
      cur.setDate(cur.getDate() + 1);
    }

    if (dates.length === 0) { setError("Aucun jour trouvé dans cette plage."); return; }
    if (!window.confirm(`Créer ${dates.length} entrée(s) de TT ?`)) return;

    setRecLoading(true);
    setError("");
    const headers = { Authorization: "Bearer " + token };
    try {
      const r = await axios.post(API + "/tt/bulk",
        { dates, commentaire: recCommentaire || "", periode: "entiere" },
        { headers });
      const { created, skipped } = r.data;
      setSuccess(`${created} jour(s) de TT créé(s)${skipped > 0 ? `, ${skipped} déjà déclaré(s) ignoré(s)` : ""}.`);
      setRecJours([]); setRecDebut(""); setRecFin(""); setRecCommentaire("");
      setShowRecurrence(false);
      setTimeout(() => setSuccess(""), 4000);
      loadTTs();
    } catch {
      setError("Erreur lors de la création de la récurrence.");
    } finally {
      setRecLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 950 }}>
      <h2 style={{ marginBottom: 20, fontWeight: 500 }}>Mon Teletravail</h2>
      <div style={{ background: "#fff", border: "1px solid #e0e0e0", borderRadius: 12, padding: 24, marginBottom: 16 }}>
        <div style={{ fontSize: 13, fontWeight: 500, color: "#333", marginBottom: 16 }}>Declarer des jours de TT</div>

        {error && <div style={{ background: "#FCEBEB", color: "#A32D2D", padding: "8px 12px", borderRadius: 6, marginBottom: 12, fontSize: 13 }}>{error}</div>}
        {success && <div style={{ background: "#EAF3DE", color: "#3B6D11", border: "1px solid #97C459", padding: "8px 12px", borderRadius: 6, marginBottom: 12, fontSize: 13, fontWeight: 500 }}>{success}</div>}

        {dateDebut && (
          <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: isJourUnique ? 12 : 16, padding: "10px 14px", background: "#f9f9f9", borderRadius: 8, fontSize: 13 }}>
            <span style={{ color: "#888" }}>Du</span>
            <span style={{ fontWeight: 500 }}>{new Date(dateDebut + "T12:00:00").toLocaleDateString("fr-FR", { day: "2-digit", month: "long" })}</span>
            <span style={{ color: "#bbb" }}>→</span>
            <span style={{ fontWeight: 500 }}>{dateFin ? new Date(dateFin + "T12:00:00").toLocaleDateString("fr-FR", { day: "2-digit", month: "long" }) : "..."}</span>
          </div>
        )}

        {isJourUnique && (
          <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
            {["entiere", "matin", "apres-midi"].map(opt => (
              <button key={opt} onClick={() => setDemiJournee(opt)}
                style={{
                  padding: "6px 14px", borderRadius: 20, border: "1px solid", fontSize: 12, cursor: "pointer",
                  fontWeight: demiJournee === opt ? 600 : 400,
                  borderColor: demiJournee === opt ? "#3B8C6E" : "#ddd",
                  background: demiJournee === opt ? "#C8EDD9" : "#fff",
                  color: demiJournee === opt ? "#3B8C6E" : "#555"
                }}>
                {opt === "entiere" ? "Journée entière" : opt === "matin" ? "Matin (½j)" : "Après-midi (½j)"}
              </button>
            ))}
          </div>
        )}

        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 12 }}>
          <button onClick={() => { const d = new Date(viewYear, viewMonth - 1); setViewMonth(d.getMonth()); setViewYear(d.getFullYear()); }}
            style={{ background: "none", border: "1px solid #ddd", borderRadius: 6, padding: "4px 12px", cursor: "pointer" }}>{"<"}</button>
          <button onClick={() => { const d = new Date(viewYear, viewMonth + 1); setViewMonth(d.getMonth()); setViewYear(d.getFullYear()); }}
            style={{ background: "none", border: "1px solid #ddd", borderRadius: 6, padding: "4px 12px", cursor: "pointer" }}>{">"}</button>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(230px, 1fr))", gap: 24, marginBottom: 20, justifyItems: "center" }}>
          {months}
        </div>

        <div style={{ marginBottom: 16 }}>
          <label style={{ fontSize: 12, color: "#666", display: "block", marginBottom: 4 }}>Commentaire (optionnel)</label>
          <input type="text" value={commentaire} onChange={e => setCommentaire(e.target.value)}
            placeholder="ex: Client X" style={{ width: "100%", padding: "7px 10px", border: "1px solid #ddd", borderRadius: 6, fontSize: 13, boxSizing: "border-box" }} />
        </div>

        <button onClick={handleSubmit}
          style={{ background: "#3B8C6E", color: "#fff", border: "none", borderRadius: 6, padding: "10px 24px", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
          Declarer
        </button>
      </div>

      {/* Récurrence hebdomadaire */}
      <div style={{ background: "#fff", border: "1px solid #e0e0e0", borderRadius: 12, padding: 20, marginBottom: 16 }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", cursor: "pointer" }}
          onClick={() => setShowRecurrence(s => !s)}>
          <div style={{ fontSize: 13, fontWeight: 600, color: "#333" }}>🔁 Récurrence hebdomadaire</div>
          <span style={{ color: "#888", fontSize: 12 }}>{showRecurrence ? "▲" : "▼"}</span>
        </div>
        {showRecurrence && (
          <div style={{ marginTop: 16 }}>
            <div style={{ fontSize: 12, color: "#666", marginBottom: 8 }}>Jours de la semaine</div>
            <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
              {JOURS.map((j, i) => {
                const idx = JOURS_IDX[i];
                const active = recJours.includes(idx);
                return (
                  <button key={j} onClick={() => setRecJours(prev => active ? prev.filter(x => x !== idx) : [...prev, idx])}
                    style={{ padding: "6px 12px", borderRadius: 6, border: `1px solid ${active ? "#3B8C6E" : "#ddd"}`,
                      background: active ? "#3B8C6E" : "#f9f9f9", color: active ? "#fff" : "#444",
                      fontWeight: active ? 700 : 400, fontSize: 13, cursor: "pointer" }}>
                    {j}
                  </button>
                );
              })}
            </div>
            <div style={{ display: "flex", gap: 12, marginBottom: 12 }}>
              <div style={{ flex: 1 }}>
                <label style={{ fontSize: 12, color: "#666", display: "block", marginBottom: 4 }}>Du</label>
                <input type="date" value={recDebut} onChange={e => setRecDebut(e.target.value)}
                  style={{ width: "100%", padding: "7px 10px", border: "1px solid #ddd", borderRadius: 6, fontSize: 13, boxSizing: "border-box" }} />
              </div>
              <div style={{ flex: 1 }}>
                <label style={{ fontSize: 12, color: "#666", display: "block", marginBottom: 4 }}>Au</label>
                <input type="date" value={recFin} onChange={e => setRecFin(e.target.value)}
                  style={{ width: "100%", padding: "7px 10px", border: "1px solid #ddd", borderRadius: 6, fontSize: 13, boxSizing: "border-box" }} />
              </div>
            </div>
            <div style={{ marginBottom: 14 }}>
              <label style={{ fontSize: 12, color: "#666", display: "block", marginBottom: 4 }}>Commentaire (optionnel)</label>
              <input type="text" value={recCommentaire} onChange={e => setRecCommentaire(e.target.value)}
                placeholder="ex: Télétravail fixe" style={{ width: "100%", padding: "7px 10px", border: "1px solid #ddd", borderRadius: 6, fontSize: 13, boxSizing: "border-box" }} />
            </div>
            {recDebut && recFin && recJours.length > 0 && (
              <div style={{ fontSize: 12, color: "#3B8C6E", marginBottom: 12 }}>
                {(() => {
                  let n = 0;
                  const cur = new Date(recDebut + "T12:00:00");
                  const end = new Date(recFin + "T12:00:00");
                  while (cur <= end) { if (recJours.includes(cur.getDay())) n++; cur.setDate(cur.getDate() + 1); }
                  return `→ ${n} jour(s) de TT à créer`;
                })()}
              </div>
            )}
            <button onClick={handleRecurrence} disabled={recLoading}
              style={{ background: "#3B8C6E", color: "#fff", border: "none", borderRadius: 6, padding: "9px 22px", fontSize: 13, fontWeight: 600, cursor: "pointer", opacity: recLoading ? 0.6 : 1 }}>
              {recLoading ? "Création..." : "Créer la récurrence"}
            </button>
          </div>
        )}
      </div>

      <div style={{ background: "#fff", border: "1px solid #e0e0e0", borderRadius: 12, padding: 16 }}>
        <div style={{ fontSize: 12, fontWeight: 500, color: "#888", marginBottom: 12, textTransform: "uppercase" }}>
          Mes declarations ({tts.length})
        </div>
        {tts.length === 0 ? (
          <div style={{ fontSize: 13, color: "#888" }}>Aucune declaration.</div>
        ) : (
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
            <thead>
              <tr>
                {["Du", "Au", "Période", "Commentaire", "Action"].map(h => (
                  <th key={h} style={{ textAlign: "left", padding: "6px 10px", fontSize: 11, color: "#888", borderBottom: "1px solid #eee" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {tts.map(t => (
                <tr key={t.id}>
                  <td style={td}>{new Date(t.date_debut).toLocaleDateString("fr-FR")}</td>
                  <td style={td}>{new Date(t.date_fin).toLocaleDateString("fr-FR")}</td>
                  <td style={td}>{t.periode === "matin" ? "🌅 Matin" : t.periode === "apres-midi" ? "🌆 Après-midi" : <span style={{ color: "#bbb" }}>Entière</span>}</td>
                  <td style={td}>{t.commentaire || <span style={{ color: "#bbb" }}>-</span>}</td>
                  <td style={td}>
                    <button onClick={() => handleDelete(t.id)}
                      style={{ background: "#FCEBEB", color: "#A32D2D", border: "1px solid #F09595", borderRadius: 4, padding: "3px 10px", fontSize: 11, cursor: "pointer" }}>
                      Supprimer
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

const td = { padding: "8px 10px", borderBottom: "1px solid #f5f5f5" };

export default TT;